import styled from 'shared/utils/styled';

export const Title = styled('p')(({ theme }) => ({
  fontSize: 19,
  fontWeight: 600,
  color: theme.palette.primary.main,
  textAlign: 'center',
}));
